export const GET_INBOX_EMAILS = 'GET_INBOX_EMAILS'
export const GET_INBOX_EMAILS_FAILED = 'GET_INBOX_EMAILS_FAILED'
export const GET_INBOX_EMAILS_SUCCEEDED = 'GET_INBOX_EMAILS_SUCCEEDED'
